/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ULID is a 26-character, sortable identifier. Its first 10 characters encode a 48-bit millisecond timestamp, which this tool decodes to a UTC date.`)
};

const es_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ULID es un identificador de 26 caracteres y ordenable. Sus primeros 10 caracteres codifican una marca de tiempo en milisegundos de 48 bits, que esta herramienta decodifica en una fecha UTC.`)
};

const de_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine ULID ist eine 26-stellige, sortierbare Kennung. Ihre ersten 10 Zeichen codieren einen 48-Bit-Zeitstempel in Millisekunden, den dieses Tool in ein UTC-Datum decodiert.`)
};

const nl_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een ULID is een 26-teken identificatie die sorteerbaar is. De eerste 10 tekens coderen een 48-bits milliseconde-tijdstempel, die dit hulpmiddel decodeert naar een UTC-datum.`)
};

const fr_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ULID est un identifiant de 26 caractères, triable. Ses 10 premiers caractères codent un horodatage de 48 bits en millisecondes, que cet outil décode en une date UTC.`)
};

const it_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ULID è un identificatore ordinabile di 26 caratteri. I suoi primi 10 caratteri codificano un timestamp di 48 bit in millisecondi, che questo strumento decodifica in una data UTC.`)
};

const pt_br2_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ULID é um identificador ordenável de 26 caracteres. Seus primeiros 10 caracteres codificam um timestamp de 48 bits em milissegundos, que esta ferramenta decodifica para uma data UTC.`)
};

const pt_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ULID é um identificador de 26 caracteres, ordenável. Os seus primeiros 10 caracteres codificam um timestamp de milissegundos de 48 bits, que esta ferramenta descodifica numa data UTC.`)
};

const ja_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID は 26 文字の並べ替え可能な識別子です。最初の 10 文字は 48 ビットのミリ秒タイムスタンプをエンコードし、このツールは UTC 日付にデコードします。`)
};

const zh_ud_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID 是一种 26 个字符、可排序的标识符。它的前 10 个字符编码了一个 48 位的毫秒级时间戳,本工具会将其解码为 UTC 日期。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_faq2_a", locale)
	if (locale === "en") return en_ud_faq2_a(inputs)
	if (locale === "es") return es_ud_faq2_a(inputs)
	if (locale === "de") return de_ud_faq2_a(inputs)
	if (locale === "nl") return nl_ud_faq2_a(inputs)
	if (locale === "fr") return fr_ud_faq2_a(inputs)
	if (locale === "it") return it_ud_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ud_faq2_a(inputs)
	if (locale === "pt") return pt_ud_faq2_a(inputs)
	if (locale === "ja") return ja_ud_faq2_a(inputs)
	return zh_ud_faq2_a(inputs)
};